"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }

var _useOrgAccount = require('shared/hooks/useOrgAccount');








 const MANAGED_BY_OPTIONS = [
  { value: 'admin', label: 'Manual' },
  { value: 'api', label: 'API' },
  { value: 'account', label: 'Account' },
]; exports.MANAGED_BY_OPTIONS = MANAGED_BY_OPTIONS

 const personName = (p) => [p.FirstName, p.LastName].filter(Boolean).join(' ') || p.Email; exports.personName = personName

// Who manages one membership (D-35): Account for an Owner/IT automatic
// membership, the API key by name, or Manual for an admin.
 const membershipLabel = (m) => {
  if (m.AccountManaged) return 'Account'
  if (m.ManagedBy === 'api') return _useOrgAccount.apiManagerLabel.call(void 0, m)
  return 'Manual'
}; exports.membershipLabel = membershipLabel

// A person's managers across their memberships, each once.
 const managedLabels = (p) => [...new Set(p.Memberships.map(exports.membershipLabel))]; exports.managedLabels = managedLabels

// Owner or IT for an account role; otherwise the org role, or which orgs
// they administer when it differs between orgs.
 const roleLabel = (p, orgName) => {
  if (p.AccountRole) return _useOrgAccount.ACCOUNT_ROLE_LABELS[p.AccountRole]
  const roles = new Set(p.Memberships.map(m => m.Role))
  if (roles.size <= 1) return _useOrgAccount.ORG_ROLE_LABELS[_nullishCoalesce(_optionalChain([p, 'access', _ => _.Memberships, 'access', _2 => _2[0], 'optionalAccess', _3 => _3.Role]), () => ( 'user'))]
  const adminOf = p.Memberships.filter(m => m.Role === 'admin').map(m => orgName(m.OrgKey))
  return `Admin in ${adminOf.join(', ')}`
}; exports.roleLabel = roleLabel
